import React from 'react';
import PropTypes from 'prop-types';
import { Check } from '@phosphor-icons/react';
import './style';

const Toggle = (props) => {
  const {
    label,
    onChange,
    checked,
    disabled,
    className,
    id,
    ...attr
  } = props;

  const onClick = (e) => {
    if (!disabled) onChange(id, e);
  };

  return (
    <div
      className={`toggle-wrapper flex gap-3${checked ? ' checked' : ''}${disabled ? ' disabled' : ''} ${className}`}
      {...attr}
    >
      <div className="label-wrapper flex flex-col justify-center gap-1">
        {label && (<span className="label text-12">{label}</span>)}
      </div>
      <div
        className={`toggle-select relative${disabled ? '' : ' cursor-pointer'}`}
        onClick={onClick}
      >
        {checked && (
          <div className="checkmark absolute">
            <Check size={14}
              color="#009D64" />
          </div>
        )}
      </div>
    </div>
  );

};

Toggle.propTypes = {
  label: PropTypes.node,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
};

Toggle.defaultProps = {
  label: '',
  onChange: () => null,
  checked: false,
  disabled: false,
  className: '',
  id: '',
};

export default Toggle;
